import React from 'react'
import WizardSummary from '../../../../../../../common/wizard/WizardSummary.jsx'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import useAccountType from '../../../../../../../hooks/useAccontType.js'

const Podsumowanie = ({ data: props }) => {
    const { tryb } = useParams()
    const { id, wersja } = useSelector((store) => store.wizard)
    const [accountType] = useAccountType()

    return (
        <>
            <WizardSummary
                failed={'Wystąpił błąd podczas walidacji danych.'}
                loading={'Walidowanie danych...'}
                success={'Dane zwalidowane poprawnie.'}
                wiz={props.wiz}
                pdfButton={tryb === 'edycja'}
                module={'sprawozdanie'}
                pdfBodyData={{
                    id,
                    userType: accountType,
                    wzor: props.wzor || 's1',
                    tmp: tryb === 'edycja' ? 'tmp' : null,
                    table: 'sprawozdania',
                    wersja: wersja ?? 1,
                }}
            />
        </>
    )
}

export default Podsumowanie
